import React from 'react';
import { useSelector } from 'react-redux';
import { TcsmStates } from '../../../root/tcsm-model';
import { useQuery } from '../../hooks/useQuery';
import { SuccessMessageWithNBA } from '../../models/epi-model';
import { MappedMessage } from './mapped-message-display';

interface Props {
	queryKey: string;
	useWarnings: string[];
	codeToSkip?: string[];
}
export function QueryArrayMessage(props: Props) {
	const { queryKey, useWarnings, codeToSkip } = props;

	const epiConfig = useSelector<TcsmStates, { [key: string]: SuccessMessageWithNBA }>(state => state?.epiProps?.siteSettingsState?.siteSettings.apiResponseMessages);

	const renderSuccess = useQuery()?.get(queryKey);

	if (!renderSuccess) return null;

	const keys = renderSuccess?.split(',');

	function renderMessage(key, isWarning) {
		if (codeToSkip?.includes(key)) {
			return null;
		}
		const mappedMessage = epiConfig[key];
		return <MappedMessage message={mappedMessage?.title} supplement={mappedMessage?.message} useWarning={isWarning} />;
	}

	return (
		<>
			{keys?.map(key => {
				return renderMessage(key, useWarnings?.includes(key));
			})}
		</>

	);
}

QueryArrayMessage.defaultProps = {
	codeToSkip:[],
};